import {Offer, OFFER_PRICE_TYPES, PriceItem} from '@chekin/core';

const firstPrice = 0;

export const getPricePerKey = (unitType: PriceItem['unit_type']) =>
  `upselling_add_to_card_form.price.${unitType?.toLocaleLowerCase() || 'per_unit'}`;

export const getUnitTitleKey = (unitType: PriceItem['unit_type']) =>
  `upselling_add_to_card_form.title.${unitType?.toLocaleLowerCase() || 'per_unit'}`;

type FormatPriceProps = {
  priceType: Offer['price_type'];
  items: Offer['items'];
};
export const formatPrice =
  (currencySymbol: string) =>
  ({priceType, items}: FormatPriceProps) => {
    const price = items?.[firstPrice]?.price;

    if (
      price !== undefined &&
      (priceType === OFFER_PRICE_TYPES.single || priceType === OFFER_PRICE_TYPES.multiple)
    ) {
      return `${currencySymbol}${price}`;
    }

    return '';
  };

export const getPrice = ({price_type, items}: Offer) => {
  if (price_type === OFFER_PRICE_TYPES.single) {
    return Number(items?.[firstPrice]?.price ?? 0);
  }
  return 0;
};

export const shouldShowPricePrefix = (items?: Offer['items']): boolean => {
  if (!items || items.length <= 1) return false;
  return true;
};
